module.exports = __webpack_public_path__ + "img/2.1d8de3df.png";